import config from "@/config"
import http from "@/utils/request"
export default {
	token: {
		url: `${config.API_URL}/token`,
		name: "登录获取TOKEN",
		post: async function(data={}){
			return await http.post(this.url, data);
		}
	},
	register: {
		url: `${config.API_URL}/register`,
		name: "用户注册",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
	saveUserInfo: {
		url: `${config.API_URL}/user_infos/user/`,
		name: "保存用户信息",
		post: async function(data){
			this.url = `${config.API_URL}/user_infos/user/` + data.id
			return await http.post(this.url, data.data);
		}
	},
	login: {
		url: `${config.API_URL}/login`,
		name: "客户登录",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
}
